import { map, pipe, reverse } from 'ramda';
import React, { FC, ReactNode } from 'react';
import { Popover } from '../..';
import { useBoolean } from '../../../../utils/hooks/useBoolean';
import { memoizedOver } from '../../../../utils/memoize';
import { TFolderLabel } from '../Breadcrumbs.types';
import { FolderItem } from './FolderItem';
import styles from './GroupedFolders.scss';
import { IOuter } from './GroupedFolders.types';

export const GroupedFolders: FC<IOuter> = ({ onItemClick, items }) => {
  const { value: isTooltipActive, setFalse: closeTooltip, toggle: toggleTooltip } = useBoolean();

  return (
    <div className={styles.container}>
      <Popover
        placement="bottom"
        shown={isTooltipActive}
        animate
        showArrow
        onClickOutside={closeTooltip}
        moveBy={{ y: 3 }}
        appendTo="viewport"
        zIndex={10000}
      >
        <Popover.Element>
          <div className={styles.icon} onClick={toggleTooltip} />
        </Popover.Element>
        <Popover.Content>
          <div className={styles.popoverContent}>
            {pipe<TFolderLabel[], TFolderLabel[], ReactNode[]>(
              reverse,
              map((item) => <FolderItem key={item.id} onClick={memoizedOver(closeTooltip, onItemClick)} item={item} />),
            )(items)}
          </div>
        </Popover.Content>
      </Popover>
    </div>
  );
};
